<template>
    <b-container class="agent-profile bg-white rounded p-3 mt-5 container">
        <div v-if="!editable">
            <b-breadcrumb class="bg-white" :items="this.breadcrumb_items"></b-breadcrumb>
        </div>
        <div v-else>
            <b-breadcrumb class="bg-white" :items="this.breadcrumb_items_editable"></b-breadcrumb>
        </div>
        <b-row>
            <b-col md="10" border-variant="light">
                <h4><b>{{this.agent.user.name}}</b></h4>
            </b-col>
            <b-col v-if="this.canEdit" md="2" border-variant="light">
                <b-button class="mb-2" id="editing" variant="success" @click="setEditable()">Edit My Profile</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="this.agent !== null">
                <b-card border-variant="light" no-body class="overflow-hidden shadow">
                    <b-row no-gutters>
                        <b-col md="3">
                            <b-card-img :src=agent_image alt="Image" class="rounded-0 vertical_center"></b-card-img>
                        </b-col>
                        <b-col md="9">
                            <b-card-body>
                                <b-card-text>
                                    <div v-if="!editable">
                                        <span v-html="this.agent.bio"></span>
                                    </div>
                                    <div v-else>
                                        <vue-editor v-model="this.agent.bio"></vue-editor>

                                        <b-button @click="submitBio" variable="success">Submit</b-button>
                                    </div>
                                </b-card-text>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <hr/>
        <b-row>
            <b-col>
                <div v-if="!editable && this.agent !== null">
                    <b-col md="11" border-variant="light">
                        <h4><b>Testimonials about {{this.agent.user.name}}</b></h4>
                    </b-col>

                    <b-col class="col">
                        <b-card border-variant="light" class="shadow">
                            <vue-chunks id="results-testimonials" ref="test" :items="this.testimonials" :columns="1"
                                        chunk-class="card-deck mb-2"
                                        item-class="card no-border">
                                <template slot-scope="slot">
                                    <b-card style="min-height: 8rem">
                                        <b-card-text class="quote">
                                            <div v-if="typeof slot.item.approved_at !== 'undefined' && slot.item.approved_at !== null">
                                                <div v-if="get_testimonial_length(slot.item.text) > 399">
                                            <span v-if="!checkifActivated(slot.item.id)"
                                                  v-html="fixHtml(stripHtml(slot.item.text).slice(0, 400))"></span>
                                                    <a v-if="!checkifActivated(slot.item.id)"
                                                       @click="activateReadMore(slot.item.id)">
                                                        <br>
                                                        <br>
                                                        <i>Read more...</i>
                                                    </a>
                                                    <span v-if="checkifActivated(slot.item.id)" v-html="slot.item.text"></span><br>
                                                    <span v-if="checkifActivated(slot.item.id) && slot.item.user_nickname !== null"
                                                          v-html="' -' + slot.item.user_nickname">
                                                    </span>
                                                </div>
                                                <div v-else>
                                                    <span v-html="slot.item.text"></span><br>
                                                    <span v-if="slot.item.user_nickname !== null"
                                                          v-html="' -' + slot.item.user_nickname">
                                                    </span>
                                                </div>
                                            </div>
                                        </b-card-text>
                                    </b-card>
                                </template>
                            </vue-chunks>
                            <b-button v-if="this.checkLength" :href=this.testimonial_url
                                      variant="default"
                                      class="pull-right">See More <i
                                class="fas fa-arrow-circle-right"></i>
                            </b-button>
                            <div v-if="canEdit">
                                <a :href="edit_route" class="btn btn-outline-secondary">
                                    Manage Testimonials
                                </a>
                            </div>
                            <div v-else>
                                <b-button variant="outline-secondary" @click="writeTestimonial">
                                    Write a Testimonial about {{ this.agent.user.name }}
                                </b-button>
                            </div>
                        </b-card>
                    </b-col>
                </div>
                <div v-else>
                    <div v-if="!editable">
                        <b-col md="12">
                            <b-button variant="outline-secondary pull-right" @click="writeTestimonial">
                                {{button_text}}
                            </b-button>
                        </b-col>
                    </div>
                </div>
            </b-col>
        </b-row>

        <div class="listing-parent">
            <b-row>
                <b-col md="6" offset-md="5" class="mt-4" v-if="!editable">
                    <h4><b>{{this.agent.user.name }}'s Listings</b></h4>
                </b-col>
                <b-col md="2" v-if="!editable">
                    <b-form-group class="form-group bg-secondary rounded p-2 mt-4 text-light">
                        <b-form-radio-group
                            v-model="selected"
                            :options="options"
                            name="radios-stacked"
                            stacked
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="!editable">
                    <browse :listing_type="this.listing_route" :listing_type_id="this.selected"></browse>
                </b-col>
            </b-row>
            <div id="loading" class="loading" v-if="isLoading">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <b-modal id="testimonialModal" ref="testimonialModal" title="Write a Testimonial" size="lg">
            <write-testimonial ref="writeTestimonial" :agent="agent"></write-testimonial>
            <div slot="modal-footer" class="w-100"></div>
        </b-modal>
    </b-container>
</template>

<script>

export default {
    name: 'agent-profile',

    created() {

        let _self = this;
         this.getAgent()
         this.getMe()
        _self.breadcrumb_items = [
            {
                'text': 'Home',
                'href': "/"
            },
            {
                'text': "About Us",
                'href': "/about"
            }
        ]
    },
    data() {
        return {
            agent_name: null,
            agent: {
                user: {
                    name: null
                },
                testimonials: []
            },
            editable: false,
            canEdit: false,
            listing_route: "agents/listings/" + this.$route.params.slug,
            window: {
                width: 0,
                height: 0
            },
            column_count: 3,
            activatedArray: [],
            readMoreActivated: false,
            breadcrumb_items: [],
            breadcrumb_items_editable: [
                {
                    'text': 'Home',
                    'href': "/"
                },
                {
                    'text': "My Dashboard",
                    'href': "/admin/dashboard"
                },
                {
                    'text': 'My Bio',
                    'href': "#"
                }
            ],
            pagination: {
                current_page: null,
                total: null,
                from: null,
                per_page: null
            },
            selected: null,
            options: [
                {text: 'Both', value: null},
                {text: 'Listing Agent', value: '1'},
                {text: 'Buyer\'s Agent', value: '2'},
            ],
            listings: [],
            totalRows: null,
            isLoading: false,
            testimonials: null,
            edit_route: "/admin/agents/testimonials/" + this.$route.params.slug
        }
    },
    methods: {
        setEditable(){
            let _self = this;

            this.editable = !_self.editable;
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        window_width() {
            return this.window.width;
        },
        checkifActivated(id) {
            return this.activatedArray.includes(id);
        },
        activateReadMore(id) {
            this.activatedArray.push(id);
        },
        goToListing(id) {
            window.location.href = "../../listing/" + id;
        },
        checkLength() {
            if(typeof this.testimonials != 'undefined' && this.testimonials != null){
                return this.testimonials.length > 3;
            }
            return false;
        },
        toast(message, variant) {
            this.$bvToast.toast(message, {
                title: variant,
                variant: variant,
                solid: true
            })
        },
        writeTestimonial() {
            this.$refs['testimonialModal'].show();
        },
        imageUploaded(imgSrc, agent) {
            let _self = this;
            _self.isLoading = true;

            this.agent = agent;
            let data = {
                file: imgSrc,
                agent: this.agent
            };

            let config = {
                header: {
                    'Content-Type': 'image/png'
                }
            };

            axios.post('/api/agents/addImage', data, config)
                .then(function (response) {
                    _self.isLoading = false;
                    if (response.data.status === false) {
                        _self.toast(response.data.message, 'danger');
                    } else {
                        _self.toast('Image Uploaded!', 'success');
                        location.reload()
                    }
                });
        },
        submitBio() {
            let _self = this;
            _self.isLoading = true;
            let endpoint = 'update';
            let data = {
                agent: _self.agent
            };
            axios.post('/api/agents/' + endpoint, data)
                .then(function (response) {
                    _self.isLoading = false;
                    if (response.data.status === false) {
                        _self.toast(response.data.message, 'danger');
                    } else {
                        _self.toast('Bio Updated!', 'success');
                    }
                });
        },
        getAgent(){
            let promise = axios.get('/api/agents/' + this.$route.params.slug);
            return promise.then((response) => {
                this.agent = response.data;
                this.user = response.data.user;
                this.agent_name = response.data.user.name;

                this.breadcrumb_items.push({
                    'text': this.agent_name,
                    'href': "#"
                })

                this.getTestimonials(this.agent.id);

            });
        },
        getMe() {
            let promise = axios.get('/api/me/');
            return promise.then((response) => {
                if (typeof response.data.agent !== 'undefined' && response.data.agent !== null) {
                    this.canEdit = response.data.agent.slug === this.$route.params.slug;
                }
            });
        },
        getTestimonials(id){
            axios.get('/api/agents/testimonials/' + id)
                .then(response => {
                    let testimonials = response.data.testimonials;
                    this.testimonials = testimonials.slice(0, 3);
                });
        },
        testimonialAdded() {
            this.$refs['testimonialModal'].hide();
            this.toast('Your testimonial has been submitted!', 'success');
        },
        get_testimonial_length(text) {
            console.log(text);
            var strippedHtml = this.stripHtml(text);
            return strippedHtml.length;
        },
        stripHtml(text) {
            return text.replace(/<[^>]+>/g, '');
        },
        fixHtml(html) {
            var div = document.createElement('div');
            div.innerHTML = html;
            return (div.innerHTML);
        },
        getConcatenatedTestimonial(text, nickname) {
            if(nickname){
                return text + ' -' + nickname
            } else {
                return text;
            }
        }
    },
    computed: {
        total() {
            if (typeof this.pagination !== 'undefined') {
                return this.pagination.total
            }
        },
        current_page() {
            if (typeof this.pagination !== 'undefined') {
                return this.pagination.current_page
            }
        },
        per_page() {
            return 6
        },
        testimonial_url() {
            if (typeof this.agent !== 'undefined') {
                return "/" + this.agent.slug + "/testimonials";
            }
        },
        agent_image() {
            if (typeof this.agent !== 'undefined') {
                if (typeof this.agent.image_url !== 'undefined' && this.agent.image_url !== null) {
                    return this.agent.image_url + "?fit=facearea&facepad=6&w=250&h=300";
                } else {
                    return "https://forman-realty-group.imgix.net/no_image_available.jpg?w=250&h=300";
                }
            }
        },
    },
    mounted() {
        this.$eventHub.$on('testimonial::added', this.testimonialAdded);
    },
}

</script>

<style lang="scss">
#loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

#loading i {
    Position: absolute;
    Top: 50%;
    Transform: translateY(-50%);
    left: 50%;
}

.listing-parent {
    position: relative;
    z-index: 0;
}

.no-border {
    border: 0;
}

.wrapper {
    position: relative;
}

.wrapper span.fas {
    position: absolute;
    top: 20px;
    left: 20px;
    color: white;
    box-shadow: 0 0 5px 5px #000;
}

.card {
    height: 100%;
    width: 100%;
}

.quote {
    position: relative;
}

.quote:before {
    content: '\201c';
    position: absolute;
    font-family: serif;
    font-weight: 700;
    top: -40px;
    left: -10px;
    font-size: 130px;
    color: blue;
    opacity: 0.1;
}

.vertical_center {
    display: flex;
    align-items: center;
}

</style>
